module.exports = __webpack_public_path__ + "img/ipad-cn-3.c649ce7.jpg";